import React, { useEffect, useState } from "react";
import "./People.css";

import Jacky from "../assets/jacky final.png";
import Mabel from "../assets/mabelc.png";
import Katie from "../assets/Katie.png";
import Stefan from "../assets/Stefan2.png";
import Tao from "../assets/Tao.png";
import Ian from "../assets/ian.png";
import Sid from "../assets/sid.png";
import Ela from "../assets/Ela.png";
import Siraj from "../assets/siraj .png";

import Mahesh from "../assets/Mahesh.png";
import Deb from "../assets/deb.png";
import David from "../assets/David.png";
import Emily from "../assets/Emily.png";
import Chris from "../assets/Chris.png";
import Pawel from "../assets/pawel.png";

/* Advisor logos */
import google from "../assets/google.png";
import bolt from "../assets/Bolt_logo.png";
import amazon from "../assets/amazon-dark.png";
import cjbs from "../assets/cambridge.png";
import imperial from "../assets/imperial-white.png";
import pa from "../assets/pa.png";
import venner from "../assets/veneer.png";
import nhs from "../assets/nhs.png";
import cambridge from "../assets/cambridge-white.png";

/* Team credential logos */
import bmw from "../assets/bmw.png";
import meta from "../assets/meta-dark.png";
import oxford from "../assets/oxford-white.png";


const advisors = [
  {
    name: "Mahesh Bhalerao",
    role: "Senior Partner, Global Director",
    image: Mahesh,
    logos: [google],
  },
  {
    name: "Debabrata Nag",
    role: "C Level @ Bolt · Ex Starcloud Advisor",
    image: Deb,
    logos: [bolt, amazon],
  },
  {
    name: "Dr. David Russell",
    role: "Partner @ PA Global Innovation & Tech Centre",
    image: David,
    logos: [pa, cambridge],
  },
  {
    name: "Dr. Pawel Piotrowicz",
    role: "Partner, Patent, UPC Representative",
    image: Pawel,
    logos: [venner, cambridge],
  },
  {
    name: "Dr. Emily Faulkner",
    role: "Innovation Scientist",
    image: Emily,
    logos: [nhs, cambridge],
  },
  {
    name: "Dr. Chris Thomas",
    role: "Expert in Residence",
    image: Chris,
    logos: [imperial, cjbs],
  },
];


const team = [
  {
    name: "Jacky",
    role: "Founder & CEO",
    signal: "BMW · AMEX · Ex-Founder, Top 4 Alibaba",
    image: Jacky,
  },
  {
    name: "Mabel",
    role: "Co-Founder & COO",
    signal: "Amazon · London Stock Exchange · Interim Head",
    image: Mabel,
  },
  {
    name: "Dr. Siraj",
    role: "Operations Officer (Growth)",
    signal: "Neuroscience · Cambridge Dr · GP",
    image: Siraj,
  },
  {
    name: "Dr. Katie",
    role: "Product Lead",
    signal: "Oxford Physics · 10+ Years EXP",
    image: Katie,
  },
  {
    name: "Ian",
    role: "Robotics",
    signal: "YC Summer · #1 EU Defense Hackathon",
    image: Ian,
  },
  {
    name: "Siddharth",
    role: "Data",
    signal: "London Stock Exchange · Senior Manager (Data)",
    image: Sid,
  },
  {
    name: "Tao",
    role: "AI / ML",
    signal: "Meta · Imperial Top 1%",
    image: Tao,
  },
  {
    name: "Stefan",
    role: "AI / ML",
    signal: "International Olympian in Informatics",
    image: Stefan,
  },
];


const teamLogos = [
  amazon,
  meta,
  bmw,
  cambridge,
  oxford,
];


export default function People() {
  const [view, setView] = useState(() => {
    const hash = window.location.hash;

    if (hash === "#team") {
      return "team";
    }

    return "advisors";
  });


  const isAdvisors = view === "advisors";


  /* ========================================
     Listen for navbar hash changes
     ======================================== */

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;

      if (hash === "#team") {
        setView("team");
      }

      if (hash === "#advisors") {
        setView("advisors");
      }
    };


    handleHashChange();


    window.addEventListener(
      "hashchange",
      handleHashChange
    );


    return () => {
      window.removeEventListener(
        "hashchange",
        handleHashChange
      );
    };
  }, []);


  /* ========================================
     Scroll to People section when hash
     comes from navbar
     ======================================== */

  useEffect(() => {
    if (
      window.location.hash === "#team" ||
      window.location.hash === "#advisors"
    ) {
      requestAnimationFrame(() => {
        const peoplePage =
          document.getElementById("people");

        if (peoplePage) {
          peoplePage.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      });
    }
  }, [view]);


  /* ========================================
     Internal Team / Advisors toggle
     ======================================== */

  const selectView = (nextView) => {
    setView(nextView);

    window.history.replaceState(
      null,
      "",
      `#${nextView}`
    );
  };


  return (
    <main
      className="peoplePage"
      id="people"
    >

      {/* ===================================
          HERO
          =================================== */}

      <section className="peopleHero">

        <div className="peopleHero__copy">
          <p>
            PEOPLE
          </p>

          <h1>
            Behind the Shared AI Brain
          </h1>
        </div>


        <div
          className="peopleSwitch"
          aria-label="People view"
        >

          <button
            type="button"
            className={
              !isAdvisors
                ? "is-active"
                : ""
            }
            onClick={() =>
              selectView("team")
            }
          >
            Team
          </button>


          <button
            type="button"
            className={
              isAdvisors
                ? "is-active"
                : ""
            }
            onClick={() =>
              selectView("advisors")
            }
          >
            Advisors
          </button>

        </div>

      </section>


      {/* ===================================
          ADVISORS
          =================================== */}

      {isAdvisors ? (

        <section
          className="advisorsSection"
          id="advisors"
        >

          <div className="peopleSectionHeader">
            <p>
              01
            </p>

            <h2>
              Industry Advisors
            </h2>
          </div>


          <div className="advisorsGrid">

            {advisors.map((advisor) => (

              <article
                className="advisorCard"
                key={advisor.name}
              >

                <img
                  className="advisorCard__photo"
                  src={advisor.image}
                  alt={advisor.name}
                />


                <h3>
                  {advisor.name}
                </h3>


                <p>
                  {advisor.role}
                </p>


                <div className="advisorCard__logos">

                  {advisor.logos.map(
                    (logo, index) => (

                      <div
                        className="advisorCard__logoSlot"
                        key={`${advisor.name}-logo-${index}`}
                      >
                        <img
                          src={logo}
                          alt=""
                        />
                      </div>

                    )
                  )}

                </div>

              </article>

            ))}

          </div>

        </section>

      ) : (

        /* ===================================
           TEAM
           =================================== */

        <section
          className="teamSection"
          id="team"
        >

          <div className="peopleSectionHeader">
            <p>
              02
            </p>

            <h2>
              Core Team
            </h2>
          </div>


          <div className="teamCredentialsLabel">
            Built by leaders from
          </div>


          <div className="teamCredentials">

            {teamLogos.map((logo, index) => (

              <img
                key={`team-logo-${index}`}
                src={logo}
                alt=""
              />

            ))}


            <span className="teamCredentials__more">
              and more...
            </span>

          </div>


          <div className="teamGrid">

            {team.map((person) => (

              <article
                className="teamCard"
                key={person.name}
              >

                <img
                  src={person.image}
                  alt={person.name}
                />


                <div className="teamCard__meta">

                  <div>

                    <h3>
                      {person.name}
                    </h3>


                    <p>
                      {person.role}
                    </p>


                    <span>
                      {person.signal}
                    </span>

                  </div>

                </div>

              </article>

            ))}

          </div>

        </section>

      )}

    </main>
  );
}